import React, { Component } from 'react';
import './VideoPlayer.css';

/**
 * Interstitial Component.
 * @constructor
 * @prop {string} activeVid - Active video path.
 * @prop {string} warn - Not supported warning.
 * @prop {string} type - Youtube / default HTML5 player
 * @prop {bool} autoPlay - Should the video autoplay
 * @prop {string} poster - Poster URL
 * @prop {bool} loop - Should the video loop
 */

class VideoPlayer extends Component {
  /**
  * Returns the Video Component
  * @return {jsx} Video Thumbs.
  */
  getPlayer(){
    let {activeVid, warn, type, autoPlay, poster, loop} = this.props;

    switch(type){
      case 'youtube':
        if(activeVid.snippet){
          return(
            <div className="video-wrapper" id="player">
              <iframe  sandbox="allow-forms allow-scripts allow-pointer-lock allow-same-origin allow-top-navigation" title="videoplayer" width="100%" height="100%" src={`https://www.youtube.com/embed/${activeVid.snippet.resourceId.videoId}?rel=0&modestbranding=1&showinfo=0&frameborder=0&cc_load_policy=1&autoplay=${autoPlay === 'true' ? 1 : 0}`} frameBorder="0" allowFullScreen>
                {warn}
              </iframe>
            </div>
          )
        }else{
          return(
            <div></div>
          )
        }
        
      default:
        return(
          <div className="video-wrapper" id="player">
            <video ref={player => { this.videoPlayer = player; }} controls={true} autoPlay={autoPlay} poster={poster} src={activeVid} loop={loop} />
          </div>
        );
    }
  }
  /**
  * Replays the current video
  */
  replay(){
    this.videoPlayer.pause();
    this.videoPlayer.currentTime = 0;
    this.videoPlayer.play();
  }
  render() {
    return (
      <div>
        { this.getPlayer() }
      </div>
    );

  }
}

export default VideoPlayer;
